import React, {
    ReactElement,
} from "react";
import {
    Button, ButtonGroup, Dropdown,
} from "react-bootstrap";
import useSelectionState, { AssignmentType, Ticket } from "../../pages/agent/selection-state";
import { ChatStatus } from "../../__generated__/api";
import Integrations from "../agent/integrations/Integrations";

interface ActionProps {
    canEdit: boolean;
    value: Ticket;
    assignment: AssignmentType;
    chatStatus: ChatStatus;
}
export default function Actions({
    canEdit, value, assignment, chatStatus,
}: ActionProps): ReactElement {
    const isAssignedToCurrentUser = assignment === AssignmentType.CURRENT_USER;
    const selectionState = useSelectionState();

    return (
        <div
            className="px-3 border-bottom border-top py-3 rounded-bottom d-flex"
        >
            <div>
                <Integrations chatId={value?.id as string} ticket={value} hasStarted={canEdit} />
            </div>

            <div className="d-flex flex-row justify-content-end flex-grow-1">
                {isAssignedToCurrentUser
                && (chatStatus === ChatStatus.Assigned || chatStatus === ChatStatus.OnHold || chatStatus === ChatStatus.Snoozed)
                && (
                    <>

                        <Dropdown as={ButtonGroup} className="me-2" drop="up">

                            <Button
                                variant="secondary"
                                className="p-2  btn-sm rounded-start"
                                onClick={() => selectionState.tranfer(selectionState.currentIdOrError)}
                            >
                                Transfer
                            </Button>

                            <Dropdown.Toggle
                                split
                                variant="secondary"
                                className="px-2 py-2 rounded-end"
                            />

                            <Dropdown.Menu flip>
                                <Dropdown.Item onClick={() => selectionState.addParticipants(selectionState.currentIdOrError)}>
                                    Add Participant
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => selectionState.markUnread(selectionState.currentIdOrError)}>
                                    Mark Unread
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => selectionState.unassign(selectionState.currentIdOrError)}>
                                    Unassign
                                </Dropdown.Item>
                                <Dropdown.Item onClick={() => selectionState.snooze(selectionState.currentIdOrError)}>
                                    Snooze
                                </Dropdown.Item>
                                {(chatStatus !== ChatStatus.OnHold) ? (
                                    <Dropdown.Item onClick={() => selectionState.hold(selectionState.currentIdOrError)}>
                                        Hold
                                    </Dropdown.Item>
                                ) : (
                                    <Dropdown.Item onClick={() => {
                                        selectionState.assignSelf(selectionState.currentId as string);
                                        selectionState.closeCurrent();
                                    }}
                                    >
                                        Unhold
                                    </Dropdown.Item>
                                )}

                            </Dropdown.Menu>
                        </Dropdown>

                        <button
                            type="button"
                            className="btn btn-danger p-2 btn-sm rounded"
                            onClick={() => selectionState.endChat(selectionState.currentId as string)}
                        >
                            End Chat
                        </button>
                    </>
                )}
                {(chatStatus === ChatStatus.ChatRequested || chatStatus === ChatStatus.Connected) && (
                    <>

                        <Dropdown as={ButtonGroup} className="me-2" drop="up">

                            <Button
                                variant="secondary"
                                className="p-2  btn-sm rounded-start"
                                onClick={() => selectionState.assignSelf(selectionState.currentId as string)}
                            >
                                Assign to me
                            </Button>

                            <Dropdown.Toggle split variant="secondary" className="px-2 py-2 rounded-end" />

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => selectionState.assign(selectionState.currentIdOrError)}>
                                    Assign
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>

                        <button
                            type="button"
                            className="btn btn-danger p-2 btn-sm rounded"
                            onClick={() => selectionState.ignore(selectionState.currentId as string)}
                        >
                            Ignore
                        </button>
                    </>
                )}
                {!isAssignedToCurrentUser
                && (chatStatus === ChatStatus.Assigned || chatStatus === ChatStatus.OnHold || chatStatus === ChatStatus.Snoozed)
                && (
                    <>
                        <button
                            type="button"
                            className="btn btn-secondary p-2 btn-sm me-2 rounded"
                            onClick={() => selectionState.takeOver(selectionState.currentId as string)}
                        >
                            Take Over
                        </button>

                        {value.isCurrentUserParticipating ? (
                            <button
                                type="button"
                                className="btn btn-danger p-2 btn-sm rounded"
                                onClick={() => selectionState.leave(selectionState.currentIdOrError)}
                            >
                                Leave
                            </button>
                        ) : (
                            <button
                                type="button"
                                className="btn btn-danger p-2 btn-sm rounded"
                                onClick={() => selectionState.participate(selectionState.currentIdOrError)}
                            >
                                Participate
                            </button>
                        )}

                    </>
                )}
                {(
                    chatStatus === ChatStatus.Finished
                || chatStatus === ChatStatus.Ignored)
                && (
                    <button
                        type="button"
                        className="btn btn-secondary p-2 btn-sm me-2 rounded"
                        onClick={() => selectionState.reopen(selectionState.currentIdOrError)}
                    >
                        {chatStatus === ChatStatus.Finished ? "Reopen" : "Unignore"}
                    </button>
                )}
            </div>

        </div>
    );
}
